type InnkeeprConfig = {
  adwordsClientId: string
  amazonClientId: string
  analyticsClientId: string
  criteoClientId: string
  dv360ClientId: string
  facebookClientId: string
  innkeeprBaseApiUrl: string
  innkeeprBaseWsUrl: string
  sentryDsn: string
  tiktokAppId: string
}

const stripUrl = (url: string, fallback: string) =>
  url ? (url.endsWith('/') ? url.slice(0, -1) : url) : fallback

const config: InnkeeprConfig = {
  adwordsClientId: window.env.ADWORDS_CLIENT_ID ?? import.meta.env.VITE_ADWORDS_CLIENT_ID,
  amazonClientId:
    window.env.AMAZON_ADS_CLIENT_ID ?? import.meta.env.VITE_AMAZON_ADS_CLIENT_ID ?? '',
  analyticsClientId:
    window.env.ANALYTICS_CLIENT_ID ?? import.meta.env.VITE_ANALYTICS_CLIENT_ID ?? '',
  criteoClientId: window.env.CRITEO_CLIENT_ID ?? import.meta.env.VITE_CRITEO_CLIENT_ID ?? '',
  dv360ClientId: window.env.DV360_CLIENT_ID ?? import.meta.env.VITE_DV360_CLIENT_ID ?? '',
  facebookClientId: window.env.FACEBOOK_CLIENT_ID ?? import.meta.env.VITE_FACEBOOK_CLIENT_ID ?? '',
  // when running in dev mode, we use a proxy mode to avoid CORS problems => see vite.config.ts
  innkeeprBaseApiUrl: import.meta.env.PROD
    ? stripUrl(import.meta.env.VITE_INNKEEPR_BASE_API_URL, 'http://localhost:8080')
    : '',
  // when running in dev mode, we use a proxy mode to ensure cookies are send => see vite.config.ts
  innkeeprBaseWsUrl: import.meta.env.PROD
    ? stripUrl(import.meta.env.VITE_INNKEEPR_BASE_WS_URL, 'http://localhost:8080')
    : '',
  sentryDsn: window.env.SENTTRY_DSN ?? import.meta.env.VITE_SENTTRY_DSN ?? '',
  tiktokAppId: window.env.TIKTOK_APP_ID ?? import.meta.env.VITE_TIKTOK_APP_ID ?? '',
}

export { config }
export type { InnkeeprConfig }
